<template>
  <div class="flex">
    <div v-for="(tag,i) in tags" :key="i"
         class="tag"
         :class="[{'bg-green': type === 'income','bg-red': type === 'expense','bg-yellow': type === 'transfer'},tagClass]">
      <span>{{ tag.title }}</span>
      <span class="triangle"
            :class="{'bg-green': type === 'income',
                'bg-red':   type === 'expense',
                'bg-yellow':type === 'transfer'}"></span>
    </div>
  </div>

</template>

<script>
export default {
  name: "Tags",
  props: {
    tags: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: (val) => ['income', 'expense', 'transfer'].includes(val)
    },
    tagClass: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">
.tag {
  @apply text-white px-3 rounded text-white mx-2 leading-relaxed whitespace-no-wrap relative;
  span {
    @apply relative;
    z-index: 2;
  }

  .triangle {
    content: '';
    @apply absolute top-0 bottom-0 m-auto rounded transform -rotate-45;
    right: -3px;
    height: 12px;
    width: 12px;
    z-index: 1;
  }
}
</style>